import { useSelector } from 'react-redux';
import {
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_RECORD_TRANSFORM,
  RESOURCE_TYPE_SCHEMA_SPECS,
} from 'js/constants/resourceTypes';

function getKeyByResourceType(resourceType: string) {
  const keys = {
    [RESOURCE_TYPE_SCHEMA_SPECS]: 'schemaSpecs',
    [RESOURCE_TYPE_DATA_SET]: 'dataSets',
    [RESOURCE_TYPE_DATA_MAP]: 'dataMaps',
    [RESOURCE_TYPE_RECORD_TRANSFORM]: 'transforms',
    [RESOURCE_TYPE_FLOW]: 'pipelines',
  };
  return keys[resourceType];
}

export function useResourceDoc(resourceType: string, id: number) {
  const docs = useSelector((state: any) => state.entities.docs);
  const resourceKey = getKeyByResourceType(resourceType);
  if (!resourceKey) return null;

  const resourceDocById = useSelector((state: any) => state[resourceKey].docById);

  const resourceDoc =
    resourceDocById[id] && docs[resourceDocById[id]] ? docs[resourceDocById[id]].text : null;

  return resourceDoc;
}
